import { render, staticRenderFns } from "./CustomerDetailAccountStatement.vue?vue&type=template&id=77d8dd80&scoped=true&"
import script from "./CustomerDetailAccountStatement.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailAccountStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d8dd80",
  null
  
)

export default component.exports